import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function MeProfileRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return <Navigate to={`/profile/${user.uid}`} replace />;
}
